import React from "react"
import styles from "./page.module.scss"
import {Heading} from "../heading/heading"

export interface PageProps {
  title: string
}

export const Page: React.FC<PageProps> = ({title, children}) => (
  <div className={styles.Page}>
    {<Heading size="large">
      {title}
    </Heading>}
    <div className={styles.PageContents}>
      {children}
    </div>
  </div>
)